/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import { apiordereeceipt
// apisystemsettingByCode
// getVerifyCode
} from '@/api';
import ExtField from '@/components/ExtField';
import ImgUpload from '@/components/ImgUpload';
import ServiceAmountTable from '../ServiceAmountTable';
import WriteExecute from './WriteExecute';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    Cell: Cell,
    CellBox: CellBox,
    XInput: XInput,
    ExtField: ExtField,
    ServiceAmountTable: ServiceAmountTable,
    WriteExecute: WriteExecute,
    ImgUpload: ImgUpload
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    oid: {
      type: String
    },
    template: {
      type: Object,
      default: function _default() {}
    },
    orderInfo: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isShowExecute: 0,
      loading: false,
      showContent1: true,
      showContent2: true,
      showContent3: true,
      currValue: this.value,
      ReceiptExtField: [],
      nodeTmplMap: {},
      totalTime: '',
      service: {},
      extServiceItems: [],
      sparePartList: [],
      moneyItemList: [],
      imageDescriList: [],
      editShow: false,
      writeShow: false,
      wait: 60,
      count: 0,
      clear: '',
      customFields: [],
      from: {
        pics: [],
        code: '',
        signImg: ''
      }
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user'])),
  watch: {
    // writeShow (val) {
    //   if (val) {
    //     this.$setLeft({
    //       control: true,
    //       onSuccess: () => {
    //         this.writeShow = false
    //       }
    //     })
    //   } else {
    //     this.$setLeft({
    //       control: true,
    //       onSuccess: () => {
    //         this.currValue = false
    //       }
    //     })
    //   }
    // }
  },
  methods: {
    // 初始化
    reload: function reload() {
      var _this = this;
      apiordereeceipt({
        oid: this.oid
      }).then(function (res) {
        if (res.success) {
          _this.nodeTmplMap = res.data.nodeTmplMap;
          _this.totalTime = res.data.total_time;
          _this.ReceiptExtField = res.data.receipt_list;
          _this.imageDescriList = res.data.image_descri_list;
          _this.service = res.data.settleMap.service;
          _this.sparePartList = res.data.settleMap.sparepart_list;
          _this.moneyItemList = res.data.settleMap.moneyItem_list;
          _this.extServiceItems = res.data.settleMap.extServiceItems;
        }
      });
    },
    // 提交回执
    uploadSign: function uploadSign(sign) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (sign) {
                  _context.next = 3;
                  break;
                }
                _this2.$vux.toast.text(i18n.tc("529"));
                return _context.abrupt("return", false);
              case 3:
                _this2.$vux.loading.show({
                  text: i18n.tc("616")
                });
                _context.next = 6;
                return apiordereeceipt({
                  id: _this2.service.id,
                  sign: sign
                }, 'put');
              case 6:
                res = _context.sent;
                setTimeout(function () {
                  _this2.$vux.loading.hide();
                }, 300);
                if (!res.success) _this2.$vux.toast.text(res.message || ''); // 失败
                _this2.reload();
                _this2.$emit('on-success');
                _this2.writeShow = false;
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.reload();
    // apisystemsettingByCode({ code: 40006 }).then(res => {
    //   if (res.success) {
    //     this.c = +res.data.value
    //   }
    // })
  }
};